module.exports = __webpack_public_path__ + "img/quesheng_img_shixiao.c30d059b.png";